import { useCallback, useEffect, useState } from 'react';
import { usePusherBusinessChannel } from "./PusherBusinessChannelProvider";
export function useBusinessChannelEventBinder(eventName, source) {
  const {
    getChannel,
    channelBusinessId
  } = usePusherBusinessChannel();
  const [listeners, setListeners] = useState([]);
  const startListening = useCallback(function (callback) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setListeners(prevListeners => [...prevListeners, {
      callback,
      options,
      isListening: false
    }]);
  }, []);
  useEffect(() => {
    if (channelBusinessId && listeners.some(l => !l.isListening)) {
      listeners.filter(l => !l.isListening).forEach(listener => {
        var _getChannel, _listener$options$onB, _listener$options;
        (_getChannel = getChannel(source)) === null || _getChannel === void 0 || _getChannel.bind(eventName, listener.callback);
        (_listener$options$onB = (_listener$options = listener.options).onBind) === null || _listener$options$onB === void 0 || _listener$options$onB.call(_listener$options);
        listener.isListening = true;
      });
    }
  }, [channelBusinessId, eventName, listeners, source]);
  useEffect(() => {
    return () => {
      var _getChannel2;
      (_getChannel2 = getChannel(source)) === null || _getChannel2 === void 0 || _getChannel2.unbind(eventName);
    };
  }, [eventName, channelBusinessId, source]);
  return {
    startListening,
    unbind: () => {
      var _getChannel3;
      (_getChannel3 = getChannel(source)) === null || _getChannel3 === void 0 || _getChannel3.unbind(eventName);
    }
  };
}